<template>
  <div>
    <el-container class="home-container">
      <!-- 头部 -->
      <el-header
        v-if="isShow.header"
        style="background: #23262e; font-size: 0; padding: 0"
      >
        <div style="display: flex; flex-direction: row">
          <div
            style="
              width: 200px;
              height: 60px;
              font-size: 16px;
              line-height: 60px;
              color: #fff;
              text-align: center;
            "
            @click="throwError"
          >
            一手 ERP
          </div>

          <div>
            <el-button
              type="text"
              style="height: 60px; color: white"
              @click="Collapse"
            >
              <i v-if="isCollapse" class="el-icon-d-arrow-right" />
              <i v-else class="el-icon-d-arrow-left" />
            </el-button>
          </div>

          <div class="header-bar">
            <el-dropdown
              style="
                padding: 0 20px;
                color: #fff;
                height: 100%;
                line-height: 60px;
                cursor: pointer;
              "
              trigger="click"
              @command="handleCommand"
            >
              <span class="el-dropdown-link">
                {{ username }}
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item divided command="logout">
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="header-bar">
              <el-button
                v-if="storehouse"
                class="header-storehouse"
                type="text"
                style="line-height: 1"
                @click="isShowDialogMobilize = true"
              >
                所属仓库：{{ storehouse }}
              </el-button>
              <el-button
                type="text"
                style="height: 60px; color: white; font-size: 20px"
                @click="showDownload"
              >
                <i class="el-icon-download" />
              </el-button>
              <!-- <el-button
                type="text"
                style="
                  margin-right: 10px;
                  height: 60px;
                  color: white;
                  font-size: 20px;
                "
                @click="openBoard"
              >
                <i class="el-icon-s-marketing" />
              </el-button> -->
              <div
                v-if="testMode"
                style="
                  width: 320px;
                  display: flex;
                  align-items: center;
                  height: 60px;
                  margin-right: 12px;
                "
              >
                <span style="font-size: 14px; white-space: nowrap; color: #fff"
                  >测试环境：</span
                >
                <el-input
                  ref="qaEnvNumInput"
                  v-model="qaEnvNum"
                  style="width: 100%"
                  size="mini"
                  type="number"
                  :readonly="inputDisabled"
                  placeholder="stable不需要填写"
                  class="input-with-prepend"
                  @input="handleQaEnvNumInput"
                >
                  <!-- <template slot="prepend">erp</template> -->
                  <el-select
                    slot="prepend"
                    v-model="qaEnv"
                    placeholder="请选择"
                    style="width: 100px"
                    :disabled="inputDisabled"
                    @change="handleQaEnvChange"
                  >
                    <el-option label="erp-feat-" value="erp-feat-"></el-option>
                    <el-option label="erp" value="erp"></el-option>
                    <el-option
                      label="erp-stable"
                      value="erp-stable"
                    ></el-option>
                  </el-select>
                  <i
                    v-show="inputDisabled"
                    slot="suffix"
                    class="el-icon-edit el-input__icon"
                    style="cursor: pointer"
                    @click="enableEnvInput"
                  />
                  <i
                    v-show="!inputDisabled"
                    slot="suffix"
                    style="cursor: pointer"
                    class="el-icon-check el-input__icon"
                    @click="envInputSave"
                  />
                </el-input>
              </div>
              <el-popover
                v-if="testMode || devMode"
                placement="bottom"
                width="400"
                style="margin-right: 12px"
              >
                <el-row type="flex">
                  <el-col flex="1">
                    <el-input v-model="osHost" clearable />
                  </el-col>
                  <el-button
                    type="primary"
                    size="small"
                    @click="handleConfirmOsHost"
                  >
                    确定
                  </el-button>
                </el-row>
                <el-button
                  slot="reference"
                  type="default"
                  size="small"
                  style="padding: 8px"
                >
                  os域名
                </el-button>
              </el-popover>
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <!-- 侧边菜单 -->
        <el-aside v-if="isShow.menu" class="home-aside" width>
          <el-menu
            id="homeElMenu"
            ref="homeElMenu"
            style="border: 0"
            class="el-menu-vertical-demo self-menu"
            background-color="#23262E"
            text-color="#fff"
            active-text-color="#f13685"
            :collapse="isCollapse"
            :default-active="defaultActive"
            unique-opened
            @select="handleSelect"
          >
            <div
              v-if="!isCollapse"
              class="search"
              :style="{
                'justify-content': isCollapse ? 'center' : 'flex-start',
              }"
            >
              <el-input
                id="searchKey"
                v-model="searchKey"
                :clearable="true"
                type="text"
                prefix-icon="el-icon-search"
                placeholder="搜索菜单"
                style="font-size: 13px"
              />
              <div class="search-kbd-wrap">
                <kbd class="search-kbd">{{ searchKeyAbdText }}</kbd>
                <kbd class="search-kbd">K</kbd>
              </div>
            </div>
            <div v-else class="search-icon">
              <i class="el-icon-search" @click="handleCollapsedChange(false)" />
            </div>
            <el-submenu
              v-for="pmenu in searchMenuList || menu"
              :key="pmenu.label"
              :index="pmenu.id.toString()"
            >
              <template #title>
                <i
                  v-if="pmenu.label == '权限管理'"
                  class="el-icon-alizhanghaoquanxianguanli"
                />
                <i
                  v-if="pmenu.label == '代采管理'"
                  class="el-icon-alicaigou-xianxing"
                />
                <i
                  v-if="pmenu.label == '仓储管理'"
                  class="el-icon-alicangkucangchu-xianxing"
                />
                <i
                  v-if="pmenu.label == '财务管理'"
                  class="el-icon-alicaiwu-xianxing"
                />
                <i
                  v-if="pmenu.label == '商家管理'"
                  class="el-icon-alihezuoguanxi-xianxing"
                />
                <i
                  v-if="pmenu.label == '数据表格管理'"
                  class="el-icon-alitubiao-zhuzhuangtu"
                />
                <i
                  v-if="pmenu.label == '业务监控'"
                  class="el-icon-alishujukanban"
                />
                <i
                  v-if="pmenu.label == '配置管理'"
                  class="el-icon-aliicon_shezhi"
                />
                <i
                  v-if="pmenu.label == '买手部管理'"
                  class="el-icon-aliquanxianshenpi"
                />
                <i v-if="pmenu.label == '消息公告'" class="el-icon-bell" />
                <i v-if="pmenu.label == '售后工单'" class="el-icon-tickets" />
                <i
                  v-if="pmenu.label == '商家消息通知'"
                  class="el-icon-message"
                />
                <i v-if="pmenu.label == '商家权限管理'" class="el-icon-key" />
                <span>{{ pmenu.label }}</span>
              </template>
              <!--<el-menu-item-group>-->
              <template v-for="cmenu in pmenu.children">
                <el-submenu
                  v-if="cmenu.children != undefined"
                  :key="pmenu.id.toString() + '-' + cmenu.id.toString()"
                  class="submenu2"
                  :index="cmenu.id.toString()"
                >
                  <template v-if="cmenu.children != undefined" #title>{{
                    cmenu.label
                  }}</template>
                  <template v-for="ccmenu in cmenu.children">
                    <el-menu-item
                      v-if="cmenu.children != undefined"
                      :key="ccmenu.id.toString()"
                      :index="ccmenu.link"
                      >{{ ccmenu.label }}</el-menu-item
                    >
                  </template>
                </el-submenu>
                <el-menu-item
                  v-if="cmenu.children == undefined"
                  :key="cmenu.id.toString()"
                  :index="cmenu.link"
                  >{{ cmenu.label }}</el-menu-item
                >
              </template>
              <!--</el-menu-item-group>-->
            </el-submenu>
          </el-menu>
        </el-aside>
        <!-- 内容 -->
        <el-main
          v-loading="$store.getters.loading"
          class="el-main"
          style="padding: 0"
        >
          <div v-if="editableTabs && editableTabs.length" class="tag-view">
            <div>
              <el-tag
                v-for="tag in editableTabs"
                :key="tag.name"
                :effect="editableTabsValue === tag.name ? 'dark' : 'plain'"
                style="margin: 5px; cursor: pointer"
                closable
                type="primary"
                @click="openNav(tag.name)"
                @close="removeTab(tag.name)"
                >{{ tag.title }}</el-tag
              >
            </div>
            <el-dropdown @command="handleCommand">
              <el-button icon="el-icon-close" size="small"></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="closeAllTag"
                  >关闭全部</el-dropdown-item
                >
                <el-dropdown-item command="closeOthersTag"
                  >关闭其他</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div style="margin: 15px">
            <template v-if="debug">
              <router-view :key="$route.fullPath"></router-view>
            </template>
            <keep-alive v-else :exclude="uncachedRouteNames">
              <router-view :key="$route.fullPath"></router-view>
            </keep-alive>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog
      :visible="isShowDialogDownload"
      width="80%"
      top="20"
      :before-close="closeDownload"
    >
      <span slot="title">
        下载列表
        <span style="color: red">(下次刷新倒计时:{{ flashTime }})</span>
      </span>
      <el-table :data="files" style="width: 100%" height="500">
        <el-table-column
          fixed
          prop="id"
          label="id"
          width="50"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="任务名"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="total_num"
          label="数据总数"
          width="100"
        ></el-table-column>
        <el-table-column label="进度" width="300">
          <template #default="scope">
            <el-progress
              :percentage="parseInt(scope.row.progress)"
              :status="scope.row.down_status == 1 ? 'success' : ''"
            ></el-progress>
          </template>
        </el-table-column>
        <el-table-column
          prop="admin_name"
          label="管理员"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="create_time"
          label="导出时间"
          width="160"
        ></el-table-column>
        <el-table-column label="下载链接" width="200">
          <template #default="scope">
            <el-button
              v-if="scope.row.canDown == 1"
              type="success"
              size="mini"
              @click="downloadFile(scope.row.fileurl)"
              >下载</el-button
            >
            <span v-if="scope.row.canDown == 0" style="color: red">
              {{ scope.row.filename }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template #default="scope">
            <span v-if="scope.row.down_status == 0">导出中</span>
            <span v-if="scope.row.down_status == 1" style="color: green">
              已完成
            </span>
            <span v-if="scope.row.down_status == 9" style="color: red">
              错误
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="error_msg"
          label="错误信息"
          width="200"
          style="color: red"
        ></el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button
              v-if="scope.row.down_status == 0"
              size="mini"
              type="danger"
              @click="stopTask(scope.row)"
              >停止</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <DialogMobilize
      v-model="isShowDialogMobilize"
      :search-params="{ admin_name: username }"
    />
  </div>
</template>

<script>
import Vue from "vue";
import Cookie from "vue-cookie";
import { cloneDeep } from "lodash-es";
import { mapGetters } from "vuex";
import Global_ from "../components/Global.vue";
import DialogMobilize from "@/pages/WarehouseWorkerList/components/DialogMobilize.vue";

const isInclude = (menu, searchKey) => {
  const text = searchKey.toLowerCase().replace(/\s+/g, "");
  if (
    (menu.label || "").toLowerCase().includes(text) ||
    (menu.pinyin || "").toLowerCase().includes(text)
  ) {
    return true;
  }
  if (Array.isArray(menu.children)) {
    menu.children = menu.children.filter((item) => isInclude(item, searchKey));
    menu.showAlways = !!menu.children.length;
    return !!menu.children.length;
  }
  return false;
};
export default {
  name: "Home",
  components: {
    DialogMobilize,
  },
  // 进入route前先fetchdata
  beforeRouteEnter(to, from, next) {
    Vue.axios.post("/erp/Common/getErpMenu", {}).then((res) => {
      if (res.data.code !== 200) {
        if (res.data.code === 201) {
          if (from.path === "/") {
            next(new Error("请先登录"));
          } else {
            next({ path: "/", replace: true });
          }
        }
      } else {
        next((vm) => {
          vm.setData(res);
          vm.$store.dispatch("getObsUploadData");
          // 刷新之后保留本页面的tag
          vm.$nextTick(() => {
            // 不显示菜单, 自然也不需要显示上面的tab了
            vm.autoAddTab(to, from);
          });
        });
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    console.log("🚀 : beforeRouteUpdate : beforeRouteUpdate");

    this.autoAddTab(to, from);
    next();
  },
  data() {
    return {
      uncachedRouteNames: ["stock/stock-out-order-detail"],
      componentsName: "home", // home.vue的唯一标识
      isCollapse: false,
      activeIndex: "1",
      activeIndex2: "1",
      menu: null,
      username: "",
      storehouse: "", // 所属仓库
      default: ["1"],
      editableTabsValue: "2",
      editableTabs: [],
      tabIndex: 0,

      isShow: {
        menu: true,
        header: true,
      },
      tabStyle: "top:60px;",
      files: [],
      timer: null,
      flashTime: 10,
      defaultActive: "",
      // tabButtonMap: {}, // 上面那个导航栏的映射 url => pids
      menu_map: {}, // 平铺的菜单映射
      // 不需要显示菜单的页面
      hide_menu_page_route_name: [
        "serviceOrderCreate",
        "PickingTaskPrint",
        "screenboard",
      ],
      searchKey: "",
      searchMenuList: null,
      timer2: null,
      searchKeyAbdText: "ctrl",
      inputDisabled: true,
      isShowDialogMobilize: false,
      osHost: "",
      qaEnv: "",
      qaEnvNum: "",
    };
  },
  computed: {
    ...mapGetters({
      isShowDialogDownload: "isShowDialogDownload",
    }),
    debug: () => process.env.NODE_ENV !== "production",
    testMode() {
      // return true;
      return process.env.NODE_ENV === "test";
    },
    devMode() {
      return process.env.NODE_ENV === "development";
    },
  },
  watch: {
    isShowDialogDownload: {
      handler(val) {
        if (val) {
          this.getDownloadList();
          this.timer = setInterval(() => {
            this.flashTime -= 1;
            if (this.flashTime === 0) {
              this.getDownloadList();
              this.flashTime = 10;
            }
          }, 1000);
        } else {
          this.flashTime = 10;
          clearInterval(this.timer);
        }
      },
    },
    searchKey(val) {
      this.searchMenuList = val
        ? cloneDeep(this.menu).filter((menuItem) =>
            isInclude(menuItem, this.searchKey)
          )
        : this.menu;
    },
    defaultActive: {
      handler() {
        clearTimeout(this.timer2);
        this.timer2 = setTimeout(() => {
          const node = document
            .getElementById("homeElMenu")
            .getElementsByClassName("el-menu-item is-active")[0];
          if (node) {
            node.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
          }
        }, 300);
      },
    },
  },
  created() {
    document.addEventListener("keydown", this.focusSearchInput);
    this.qaEnv = localStorage.getItem("qaEnv") || "";
    this.qaEnvNum = localStorage.getItem("qaEnvNum") || "";
    this.osHost = localStorage.getItem("osHost") || "";
    if (!this.qaEnv || !this.qaEnvNum) {
      // defaults to erp-stable and set localstorage.
      this.qaEnv = "erp-stable";
      this.qaEnvNum = "";
      localStorage.setItem("qaEnv", "erp-stable");
      localStorage.setItem("qaEnvNum", "");
    }
    if (!this.osHost) {
      this.osHost = "http://osweb-main.yishou.com";
      localStorage.setItem("osHost", "http://osweb-main.yishou.com");
    }
    this.getPosType();
    this.watchUserChange();
    this.hideMenuAndHeader();
    this.listenTabEvent();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearTimeout(this.timer2);
    document.removeEventListener("keydown", this.focusSearchInput);
  },
  methods: {
    // 快捷键聚焦搜索框
    focusSearchInput() {
      const isKeyboardK = window?.event?.key === "k";
      const isMacCommand = window?.event?.metaKey; // max
      const isWindowCtrl = window?.event?.ctrlKey; // window
      if ((isKeyboardK && isMacCommand) || (isKeyboardK && isWindowCtrl)) {
        window.event.preventDefault(); // 屏蔽window浏览器组合键 ctrl+k
        document.getElementById("searchKey").focus();
      }
    },
    // 获取系统、浏览器信息
    getPosType() {
      const agent = navigator.userAgent.toLowerCase();
      const isMac = /macintosh|mac os x/i.test(agent);
      this.searchKeyAbdText = isMac ? "⌘" : "ctrl";
    },
    throwError() {
      throw new Error(`new error at ${Date.now()}`);
    },
    // 点击菜单
    addTabButton(nav) {
      // 存在就不添加
      let add = 1;
      for (const t in this.editableTabs) {
        if (this.editableTabs[t].content == nav.link) {
          add = 0;
          break;
        }
      }

      if (add == 1) {
        this.editableTabs.push({
          title: nav.label,
          name: nav.link,
          content: nav.link,
        });
        // 这个map
        // this.$set(this.tabButtonMap, nav.link, {
        //     'pids': nav.pids,
        //     'title':nav.label,
        // });
      }
      this.editableTabsValue = nav.link;
      this.menuActive(nav.link);
    },
    // 关闭导航栏
    removeTab(targetName) {
      const tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
      if (this.editableTabs.length > 0) {
        // 关闭上面的tab之后, 要自动跳转到最后一个tab
        this.openNav(this.editableTabs[this.editableTabs.length - 1].name);
      } else {
        // 如果上面没有tab了 就去主页
        this.openNav("");
      }
      // 关闭页面之后清除绑定销毁掉实列
      // console.dir(this.$vnode.componentInstance.$children[0].$children[1].$children[1].$children);
      this.$vnode.componentInstance.$children[0].$children[1].$children[1].$children.some(
        (v, k) => {
          if (k === 0) return; // 第一个肯定是el-tabs
          // 如果加了节点之后 这里的不是页面内容, 请改一下
          if (v.$vnode.key === `/home${targetName}`) {
            if (
              typeof v.shouldKeepAlive === "function" &&
              v.shouldKeepAlive()
            ) {
              v.removeTabDone();
            } else {
              v.$destroy();
            }
            return true; // 阻止循环
          }
        }
      );
    },
    // 点击导航栏
    openNav(name) {
      // 在有搜索词下，因菜单改变，原有菜单可能已不在，因此需要重置
      this.searchKey = "";
      this.$nextTick(() => {
        // 如果只是字符串 自动补全成对象吧
        if (typeof name === "string") {
          name = {
            $options: {
              propsData: { name },
            },
          };
        }

        // 分播列表自动刷新,需要用随机数
        if (name.$options.propsData.name === "/wavepicking/devicecut") {
          this.$router.push(
            `/home${name.$options.propsData.name}?r=${Math.random(1000, 9999)}`
          );
        } else {
          this.$router.push(`/home${name.$options.propsData.name}`);
        }
        // 定位到菜单栏
        this.menuActive(name.$options.propsData.name);
      });
    },

    // 选中菜单栏里面的对应的选项
    menuActive(uri) {
      // 菜单关闭状态就不定位了, 随便了
      if (this.isCollapse) return;
      const t_map = this.menu_map[uri]; // .pids;
      if (t_map && t_map.pids.length > 0) {
        const len = t_map.pids.length - 1;
        t_map.pids.every((v, k) => {
          // 展开所有父级菜单
          this.$refs.homeElMenu.open([v]);
          return len == k;
        });
      }

      this.defaultActive = uri;
    },

    // routeUpdate和routeEnter的监听, 自动加导航栏
    autoAddTab(toRouteItem) {
      if (this.hide_menu_page_route_name.includes(toRouteItem.name)) {
        return;
      }
      const link = this.filterUriPrefix(toRouteItem.fullPath);
      let title = toRouteItem.meta.title || "未命名页面";
      if (!link) {
        return;
      }
      // 优选取用菜单上定义的名字
      if (this.menu_map[link]) {
        title = this.menu_map[link].title;
      }

      // 添加导航栏
      this.addTabButton({
        label: title, // tab的名字
        link,
      });
    },

    Collapse() {
      this.isCollapse = !this.isCollapse;
    },

    // 过滤掉uri内的/home前缀
    filterUriPrefix(uri) {
      return uri.replace("/home", "");
    },

    handleSelect(key, keyPath) {
      this.default = keyPath;
      // 分播列表自动刷新,需要用随机数
      if (key === "/wavepicking/devicecut") {
        this.$router.push(`/home${key}?r=${Math.random(1000, 9999)}`);
      } else {
        this.$router.push(`/home${key}`);
      }
    },
    handleCommand(command) {
      const func = {
        logout: () => {
          const url = "/erp/admin/logoutToSite";
          this.$http.post(url).then((res) => {
            if (res.data.code !== 200) {
              this.$message.error("登出失败,请联系管理员");
            } else {
              Cookie.set("deskNo", "");
              Cookie.set("deskNoCheck", "");
              Cookie.set("boxNo", "");
              Cookie.set("PcQualityCheckType", "");
              if (this.$route.fullPath !== "/") {
                this.$router.replace("/");
              }
            }
          });
        },
        roleAdministration: () => {
          this.$router.push("/home/adminroletree");
        },
        groupAdministration: () => {
          this.$router.push("/home/admingrouptree");
        },
        roleAdminList: () => {
          this.$router.push("/home/adminlist");
        },
        roleAdminListToGroup: () => {
          this.$router.push("/home/adminlisttogroup");
        },
        closeAllTag: () => {
          this.editableTabs = [];
          this.editableTabsValue = "";
          this.openNav("");
        },
        closeOthersTag: () => {
          this.editableTabs = this.editableTabs.filter(
            (tab) => tab.name === this.editableTabsValue
          );
        },
      };
      if (func[command]) {
        func[command]();
      }
    },
    setData(res) {
      if (res.data.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        this.menu = res.data.data;
        this.$nextTick(() => {
          this.reflushSetTab();
        });
      }
    },

    // 刷新页面的之后没有选中菜单
    // add comment
    reflushSetTab() {
      const path = this.filterUriPrefix(this.$route.path);
      // 理论上的无限级菜单(实际上只有三层 上面的代码也只写了三层), 递归
      // 把父id一层层赋予
      const fn = (childs, pids) => {
        for (let i = 0; i < childs.length; i++) {
          if (!childs[i].pids) childs[i].pids = [...pids];

          childs[i].pids.push(childs[i].id);

          if (childs[i].link == path) {
            // this.defaultActive = childs[i].link; // 选中菜单
            this.menuActive(childs[i].link);
            // 添加到导航栏, 这里在routeEnter的时候默认了加进去
            // this.addTabButton({
            //     'label': childs[i].label,
            //     'link': childs[i].link,
            //     'pids':childs[i].pids
            // });
          }
          // 平铺菜单, uri=>{pids, title}
          // add comment
          this.menu_map[childs[i].link] = {
            pids: childs[i].pids,
            title: childs[i].label,
          };
          if (childs[i].children) fn(childs[i].children, childs[i].pids);
        }
      };

      fn(this.menu, []);
    },

    // 外部调用时不需要菜单 2019.07.13
    hideMenuAndHeader() {
      // 写入路由名
      if (this.hide_menu_page_route_name.includes(this.$route.name)) {
        for (const key in this.isShow) {
          this.$set(this.isShow, key, false);
        }
      }
    },
    showDownload() {
      this.$store.commit("TOGGLE_DOWNLOAD_DIALOG", true);
    },
    closeDownload() {
      this.$store.commit("TOGGLE_DOWNLOAD_DIALOG", false);
    },
    /**
     * 获取导出任务列表
     */
    getDownloadList() {
      this.$http.post("/erp/DownloadTask/lst").then((res) => {
        if (String(res.data.code) !== "200") {
          this.closeDownload();
          this.$message.error(res.data.msg);
        } else {
          this.files = res.data.data.list;
        }
      });
    },
    stopTask(row) {
      this.$http
        .post("/erp/DownloadTask/stopTask", {
          id: row.id,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.$message.success("终止成功");
            this.showDownload();
          }
        });
    },
    openBoard() {
      this.downloadFile(
        Global_.environment == 0
          ? "/#/home/monitor/board"
          : "/erp/#/home/monitor/board"
      );
    },
    downloadFile(fileurl) {
      window.open(fileurl);
    },

    // / 监听cookie的变化, 获取并更新正确的user_name
    watchUserChange() {
      this.username = this.$cookie.get("username");
      this.storehouse = this.$cookie.get("storehouse_name");
      const timer = setInterval(() => {
        this.username = this.$cookie.get("username");
        // 没有找到cookie的用户名, 自动跳转到登陆页面
        if (!this.username) {
          clearInterval(timer); // 清除计时器
          this.handleCommand("logout");
        }
      }, 10000);
    },
    handleCollapsedChange(state) {
      this.isCollapse = state;
      if (state) {
        this.searchKey = "";
      }
    },
    listenTabEvent() {
      /**
       * TODO 全局移除tag的方法，目前先这样处理，后面放到vuex优化处理
       * */
      this.$bus.$on("removeTab", this.removeTab);
      this.$once("hook:beforeDestroy", () => {
        this.$bus.$off("removeTab");
      });
    },
    enableEnvInput() {
      this.inputDisabled = false;
    },
    envInputSave() {
      localStorage.setItem("qaEnvNum", this.qaEnvNum);
      localStorage.setItem("qaEnv", this.qaEnv);
      this.inputDisabled = true;
      window.location.reload();
    },
    handleConfirmOsHost() {
      localStorage.setItem("osHost", this.osHost);
      window.location.reload();
    },
    handleQaEnvChange(value) {
      if (value === "erp-stable") {
        this.qaEnvNum = "";
      }
    },
    handleQaEnvNumInput() {
      if (this.qaEnv === "erp-stable") {
        this.qaEnvNum = "";
      }
    },
  },
};
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 180px;
  height: 100%;
  overflow-y: auto;
}

.el-menu-vertical-demo::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.el-menu-item.is-active {
  background: #1c1e25 !important;
}

.header_tab .el-tabs__header {
  margin-bottom: 0 !important;
}
</style>
<style scroped lang="css">
*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #ccc;
  border-radius: 8px;
}

*::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 8px;
}

.tag-view {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 99;
  border-bottom: 1px solid #eee;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.home-container {
  height: 100vh;
}

.home-aside {
  background: #23262e;
  height: calc(100vh - 60px);
  overflow: auto;
}

.home-aside::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.el-main {
  padding: 0;
  width: 100%;
  height: calc(100vh - 60px);
  overflow: auto;
}

.home-menu {
  height: 100%;
}

.el-menu-item-group__title {
  padding: 0;
}

.search {
  /* width: 180px; */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  position: sticky;
  top: 0;
  z-index: 999;
  background: rgb(35, 38, 46);
}

.search-icon {
  /* display: flex;
  justify-content: center;
  align-items: center; */
  color: #909399;
  background-color: rgb(35, 38, 46);
  padding: 0 20px;
  font-size: 14px;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  height: 56px;
  line-height: 56px;
}

.search-icon .el-icon-search {
  margin: 0;
  vertical-align: middle;
  width: 24px;
  text-align: center;
  font-size: 18px;
}

.header-bar {
  flex: 1;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}

.header-storehouse {
  margin-left: 20px;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #fff;
}

.search-kbd-wrap {
  align-items: center;
  display: flex;
  gap: 4px;
  height: 100%;
  justify-content: center;
  pointer-events: none;
  position: absolute;
  right: 16px;
  top: 0;
}

.search-kbd {
  background-color: #fff;
  border: 1px solid #bec3c9;
  box-shadow: inset 0 -1px 0 #bec3c9;
  color: #bec3c9;
  border-radius: 0.2rem;
  padding: 0.12rem 0.26rem;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  appearance: textfield;
}

/* 菜单名称过长 */
.el-submenu .el-menu .el-menu-item {
  word-break: break-all;
  white-space: break-spaces;
  line-height: 20px;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue